// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_base-page-header_wrapper_2pUbk","inner__right":"_base-page-header_inner__right_38uLQ","inner__center":"_base-page-header_inner__center_-OwXd"};